var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass: "col-12 form-group form-group__animated mb-0",
        class: { "form-group--error": !_vm.validation.pass_first },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.pass_first,
              expression: "value.pass_first",
            },
          ],
          staticClass:
            "form-group__input form-group__input--paddings-classic form-group__animated__input",
          attrs: {
            type: "password",
            name: "password",
            id: "password",
            placeholder: "password",
          },
          domProps: { value: _vm.value.pass_first },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.value, "pass_first", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            attrs: { for: "password" },
          },
          [_vm._v(_vm._s(_vm.$t("password", "form_passwords")))]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 mb-3 ml-1" }, [
      _c(
        "span",
        {
          staticClass:
            "heading__desc--small font__family--gotham font__weight--light",
          class: { "font__color--error": !_vm.validation.pass_first },
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("password_strength_info", "form_passwords")) +
              "\n        "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 form-group form-group__animated",
        class: { "form-group--error": !_vm.validation.pass_repeat },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.pass_repeat,
              expression: "value.pass_repeat",
            },
          ],
          staticClass:
            "form-group__input form-group__input--paddings-classic form-group__animated__input",
          attrs: {
            type: "password",
            name: "password",
            id: "password_repeat",
            placeholder: "password_repeat",
          },
          domProps: { value: _vm.value.pass_repeat },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.value, "pass_repeat", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            attrs: { for: "password_repeat" },
          },
          [_vm._v(_vm._s(_vm.$t("repeate_password", "form_passwords")))]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-12" }, [
      !_vm.validation.the_same_passwords
        ? _c(
            "p",
            {
              staticClass:
                "heading__desc font__family--gotham font__weight--light font__color--error m-0",
            },
            [_vm._v("\n            " + _vm._s(_vm.message))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }